import React, { useEffect, useState } from "react";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Cookies from "js-cookie";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import Nodatafound from "../Nodatafound";

function Projectlist() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [newslist, setNewslist] = useState([]);
  const [paginate,setPaginate]=useState("");
  const [pagenum,setPagenum]=useState(1);

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/project/get-projects?page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();
      setNewslist(data.data[0].data);
      setPaginate(data.data[0].total_pages);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/project/delete-project/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();

      toast.success(" Project deleted", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }else {
      console.log("error");

    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/project/get-projects?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if(res.status === 200){
    const data = await res.json();
    return data.data[0].data;
  }
  else if(res.status === 401){
    handleUnauthorized();
    fetchComments(currentPage);
  }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setNewslist(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setNewslist(commentsFormServer);
    }
    
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Project List</h4>
                    <div className="table-responsive pt-3">
                    {newslist?.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl.no</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Location</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {newslist.map((element, i) => {
                            return (
                              <>
                                <tr>
                                  <th scope="row">{i + 1}</th>
                                  <td>{element?.projectName}</td>
                                  <td>{element?.projectStatus}</td>
                                  <td>{element?.location}</td>

                                  {/* <td><img src={element.newsImage} width="50" /></td> */}
                                  <td className="actions_td">
                                    <Link
                                      // onClick={() => deletenews(element._id)}
                                      onClick={() => tog_animationFlip(element._id)}

                                      className="margins-2 action_icons"
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </Link>
                                 
                                      <Link
                                        to={"/editproject/" + element._id}
                                        className="fa-solid fa-pen action_icons"
                                       
                                      ></Link>
                                   

                                    
                                              <Link to={"/projectview/" + element._id}  className="action_icons" >
                                             <i className="fa-solid fa-eye" />
                                             </Link>
                                          
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                      :
                      <Nodatafound/>
                    }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Project"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Projectlist;
